import { CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Tabs } from 'antd';
import React from 'react';
import styles from './index.module.scss';
import './index.scss';
import ViewBankDetails from './ViewBankDetails';
import ViewCompanyDetails from './ViewCompanyDetails';
import ViewCurrencyDetails from './ViewCurrencyDetails';
import ViewIntegrationDetails from './ViewIntegrationDetails';

type Props = {
	isOpen: boolean;
	onCancel: () => void;
	company: any;
};

const ViewCompanyModal = (props: Props) => {
	const { isOpen, onCancel, company } = props;
	const [activeKey, setActiveKey] = React.useState('companyDetails');
	const changeTab = (key: any) => {
		setActiveKey(key);
	};

	let tabItems = [
		{
			key: 'companyDetails',
			label: 'Company Details',
			children: <ViewCompanyDetails companyData={company} />,
		},
		{
			key: 'bankDetails',
			label: 'Bank Details',
			children: <ViewBankDetails companyData={company} />,
		},
		{
			key: 'currency',
			label: 'Currency Setup',
			children: <ViewCurrencyDetails companyData={company} />,
		},
		// {
		// 	key: 'integrationDetails',
		// 	label: 'Integration Details',
		// 	children: <ViewIntegrationDetails companyData={company} />,
		// },
	];

	return (
		<Modal
			open={isOpen}
			onCancel={onCancel}
			footer={null}
			width={1000}
			className="edit-company"
			closable={false}
		>
			<div className={styles['modal-header']}>
				<div className={styles['title']}>
				</div>
				<Button
					className={styles['close-button']}
					icon={<CloseOutlined />}
					onClick={onCancel}
				/>
			</div>
			<div className={styles['company-component']}>
				<div className="company-component-tabs">
					<Tabs
						defaultActiveKey={activeKey}
						activeKey={activeKey}
						items={tabItems}
						onChange={(key) => changeTab(key)}
						style={{
							fontSize: '18px',
							marginBottom: '40px',
						}}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default ViewCompanyModal;
